import { fileConstants } from "../constants";
import { fileRequests } from "../../services";
import { handleErrorMessage } from "../../utils";

export const fileActions = {};

fileActions.CheckAcceptanceConfirm = (data) => {
  return (dispatch) => {
    dispatch(request());
    fileRequests.CheckAcceptanceConfirm(data).then(
      (fileCheck) => dispatch(success(fileCheck)),
      (error) => dispatch(failure(handleErrorMessage(error)))
    );
  };

  function request() {
    return { type: fileConstants.FILE_CHECK_REQUEST };
  }

  function success(fileCheck) {
    return { type: fileConstants.FILE_CHECK_SUCCESS, fileCheck };
  }

  function failure(error) {
    return { type: fileConstants.FILE_CHECK_FAILURE, error };
  }
};

fileActions.UpdateMetadata = (data) => {
  return (dispatch) => {
    dispatch(request());
    fileRequests.UpdateMetadata(data).then(
      (fileData) => dispatch(success(fileData)),
      (error) => dispatch(failure(handleErrorMessage(error)))
    );
  };

  function request() {
    return { type: fileConstants.UPDATE_METADATA_REQUEST };
  }

  function success(fileData) {
    return { type: fileConstants.UPDATE_METADATA_SUCCESS, fileData };
  }

  function failure(error) {
    return { type: fileConstants.UPDATE_METADATA_FAILURE, error };
  }
};

fileActions.GetFileByGUID = (data) => {
  return (dispatch) => {
    dispatch(request());
    fileRequests.GetFileByGUID(data).then(
      (fileInfoGuid) => dispatch(success(fileInfoGuid)),
      (error) => dispatch(failure(handleErrorMessage(error)))
    );
  };

  function request() {
    return { type: fileConstants.FILE_GUID_REQUEST };
  }

  function success(fileInfoGuid) {
    return { type: fileConstants.FILE_GUID_SUCCESS, fileInfoGuid };
  }

  function failure(error) {
    return { type: fileConstants.FILE_GUID_FAILURE, error };
  }
};

fileActions.GetFileInfo = (data, isReset = false) => {
  return (dispatch) => {
    if (isReset) {
      dispatch(reset());
    } else {
      dispatch(request());
      fileRequests.GetFileInfo(data).then(
        (fileInfo) => dispatch(success(fileInfo)),
        (error) => dispatch(failure(handleErrorMessage(error)))
      );
    }
  };

  function request() {
    return { type: fileConstants.FILE_INFO_REQUEST };
  }

  function success(fileInfo) {
    return { type: fileConstants.FILE_INFO_SUCCESS, fileInfo };
  }

  function failure(error) {
    return { type: fileConstants.FILE_INFO_FAILURE, error };
  }

  function reset() {
    return { type: fileConstants.FILE_INFO_RESET };
  }
};

fileActions.GetTextEvidence = (data) => {
  return (dispatch) => {
    dispatch(request());
    fileRequests.GetTextEvidence(data).then(
      (fileText) => dispatch(success(fileText)),
      (error) => dispatch(failure(handleErrorMessage(error)))
    );
  };

  function request() {
    return { type: fileConstants.FILE_TEXT_REQUEST };
  }

  function success(fileText) {
    return { type: fileConstants.FILE_TEXT_SUCCESS, fileText };
  }

  function failure(error) {
    return { type: fileConstants.FILE_TEXT_FAILURE, error };
  }
};

fileActions.GenerateFolioChildWorkflow = (data) => {
  return (dispatch) => {
    dispatch(request());
    fileRequests.GenerateFolioChildWorkflow(data).then(
      (folioChildWf) => dispatch(success(folioChildWf)),
      (error) => dispatch(failure(handleErrorMessage(error)))
    );
  };

  function request() {
    return { type: fileConstants.FOLIO_WF_REQUEST };
  }

  function success(folioChildWf) {
    return { type: fileConstants.FOLIO_WF_SUCCESS, folioChildWf };
  }

  function failure(error) {
    return { type: fileConstants.FOLIO_WF_FAILURE, error };
  }
};

fileActions.GenerateFolioRemote = (data) => {
  return (dispatch) => {
    dispatch(request());
    fileRequests.GenerateFolioRemote(data).then(
      (folioRemoteData) => dispatch(success(folioRemoteData)),
      (error) => dispatch(failure(handleErrorMessage(error)))
    );
  };

  function request() {
    return { type: fileConstants.FOLIOREMOTE_REQUEST };
  }

  function success(folioRemoteData) {
    return { type: fileConstants.FOLIOREMOTE_SUCCESS, folioRemoteData };
  }

  function failure(error) {
    return { type: fileConstants.FOLIOREMOTE_FAILURE, error };
  }
};

fileActions.CheckDeAceptacionPDF = (data) => {
  return (dispatch) => {
    dispatch(request());
    fileRequests.CheckDeAceptacionPDF(data).then(
      (checkPdfData) => dispatch(success(checkPdfData)),
      (error) => dispatch(failure(handleErrorMessage(error)))
    );
  };

  function request() {
    return { type: fileConstants.FILECHECKPDF_REQUEST };
  }

  function success(checkPdfData) {
    return { type: fileConstants.FILECHECKPDF_SUCCESS, checkPdfData };
  }

  function failure(error) {
    return { type: fileConstants.FILECHECKPDF_FAILURE, error };
  }
};

fileActions.SetOptionsToSelect = (data) => {
  return (dispatch) => {
    dispatch(request());
    fileRequests.SetOptionsToSelect(data).then(
      (options) => dispatch(success(options)),
      (error) => dispatch(failure(handleErrorMessage(error)))
    );
  };

  function request() {
    return { type: fileConstants.FILE_OPTIONS_REQUEST };
  }

  function success(options) {
    return { type: fileConstants.FILE_OPTIONS_SUCCESS, options };
  }

  function failure(error) {
    return { type: fileConstants.FILE_OPTIONS_FAILURE, error };
  }
};

fileActions.GetFilesSearch = (data) => {
  return (dispatch) => {
    dispatch(request());
    fileRequests.GetFilesSearch(data).then(
      (files) => dispatch(success(files)),
      (error) => dispatch(failure(handleErrorMessage(error)))
    );
  };

  function request() {
    return { type: fileConstants.FILES_SEARCH_REQUEST };
  }

  function success(files) {
    return { type: fileConstants.FILES_SEARCH_SUCCESS, files };
  }

  function failure(error) {
    return { type: fileConstants.FILES_SEARCH_FAILURE, error };
  }
};

fileActions.GenerateFolio = (data) => {
  return (dispatch) => {
    dispatch(request());
    fileRequests.GenerateFolio(data).then(
      (folio) => dispatch(success(folio)),
      (error) => dispatch(failure(handleErrorMessage(error)))
    );
  };

  function request() {
    return { type: fileConstants.GENERATE_FOLIO_REQUEST };
  }

  function success(folio) {
    return { type: fileConstants.GENERATE_FOLIO_SUCCESS, folio };
  }

  function failure(error) {
    return { type: fileConstants.GENERATE_FOLIO_FAILURE, error };
  }
};

fileActions.GetActorByGroup = (data) => {
  return (dispatch) => {
    dispatch(request());
    fileRequests.GetActorByGroup(data).then(
      (groupSearch) => dispatch(success(groupSearch)),
      (error) => dispatch(failure(handleErrorMessage(error)))
    );
  };

  function request() {
    return { type: fileConstants.SEARCH_GROUP_REQUEST };
  }

  function success(groupSearch) {
    return { type: fileConstants.SEARCH_GROUP_SUCCESS, groupSearch };
  }

  function failure(error) {
    return { type: fileConstants.SEARCH_GROUP_FAILURE, error };
  }
};

fileActions.GetActors = (data) => {
  return (dispatch) => {
    dispatch(request());
    fileRequests.GetActors(data).then(
      (actors) => dispatch(success(actors)),
      (error) => dispatch(failure(handleErrorMessage(error)))
    );
  };

  function request() {
    return { type: fileConstants.GET_ACTORS_REQUEST };
  }

  function success(actors) {
    return { type: fileConstants.GET_ACTORS_SUCCESS, actors };
  }

  function failure(error) {
    return { type: fileConstants.GET_ACTORS_FAILURE, error };
  }
};

fileActions.SetGroupName = (data) => {
  return (dispatch) => {
    dispatch(request());
    fileRequests.SetGroupName(data).then(
      (groupName) => dispatch(success(groupName)),
      (error) => dispatch(failure(handleErrorMessage(error)))
    );
  };

  function request() {
    return { type: fileConstants.GROUP_NAME_REQUEST };
  }

  function success(groupName) {
    return { type: fileConstants.GROUP_NAME_SUCCESS, groupName };
  }

  function failure(error) {
    return { type: fileConstants.GROUP_NAME_FAILURE, error };
  }
};

fileActions.RegisterActor = (data) => {
  return (dispatch) => {
    dispatch(request());
    fileRequests.RegisterActor(data).then(
      (newActor) => dispatch(success(newActor)),
      (error) => dispatch(failure(handleErrorMessage(error)))
    );
  };

  function request() {
    return { type: fileConstants.REGISTER_ACTOR_REQUEST };
  }

  function success(newActor) {
    return { type: fileConstants.REGISTER_ACTOR_SUCCESS, newActor };
  }

  function failure(error) {
    return { type: fileConstants.REGISTER_ACTOR_FAILURE, error };
  }
};

fileActions.StartActorFlow = (data) => {
  return (dispatch) => {
    dispatch(request());
    fileRequests.StartActorFlow(data).then(
      (startActor) => dispatch(success(startActor)),
      (error) => dispatch(failure(handleErrorMessage(error)))
    );
  };

  function request() {
    return { type: fileConstants.START_ACTOR_REQUEST };
  }

  function success(startActor) {
    return { type: fileConstants.START_ACTOR_SUCCESS, startActor };
  }

  function failure(error) {
    return { type: fileConstants.START_ACTOR_FAILURE, error };
  }
};

fileActions.RemoveActor = (data) => {
  return (dispatch) => {
    dispatch(request());
    fileRequests.RemoveActor(data).then(
      (deletedActor) => dispatch(success(deletedActor)),
      (error) => dispatch(failure(handleErrorMessage(error)))
    );
  };

  function request() {
    return { type: fileConstants.REMOVE_ACTOR_REQUEST };
  }

  function success(deletedActor) {
    return { type: fileConstants.REMOVE_ACTOR_SUCCESS, deletedActor };
  }

  function failure(error) {
    return { type: fileConstants.REMOVE_ACTOR_FAILURE, error };
  }
};

fileActions.UpdateActorsRole = (data) => {
  return (dispatch) => {
    dispatch(request());
    fileRequests.UpdateActorsRole(data).then(
      (updatedInfo) => dispatch(success(updatedInfo)),
      (error) => dispatch(failure(handleErrorMessage(error)))
    );
  };

  function request() {
    return { type: fileConstants.UPDATE_ACTORS_REQUEST };
  }

  function success(updatedInfo) {
    return { type: fileConstants.UPDATE_ACTORS_SUCCESS, updatedInfo };
  }

  function failure(error) {
    return { type: fileConstants.UPDATE_ACTORS_FAILURE, error };
  }
};

fileActions.SetManualConfigurations = (data) => {
  return (dispatch) => {
    dispatch(request());
    fileRequests.SetManualConfigurations(data).then(
      (manualConfig) => dispatch(success(manualConfig)),
      (error) => dispatch(failure(handleErrorMessage(error)))
    );
  };

  function request() {
    return { type: fileConstants.MANUAL_CONFIGURATIONS_REQUEST };
  }

  function success(manualConfig) {
    return { type: fileConstants.MANUAL_CONFIGURATIONS_SUCCESS, manualConfig };
  }

  function failure(error) {
    return { type: fileConstants.MANUAL_CONFIGURATIONS_FAILURE, error };
  }
};

fileActions.ContinueStageActorSelection = (data) => {
  return (dispatch) => {
    dispatch(request());
    fileRequests.ContinueStageActorSelection(data).then(
      (ContStageActorData) => dispatch(success(ContStageActorData)),
      (error) => dispatch(failure(handleErrorMessage(error)))
    );
  };

  function request() {
    return { type: fileConstants.CONTINUE_STAGE_ACTOR_SELECTTION_REQUEST };
  }

  function success(ContStageActorData) {
    return {
      type: fileConstants.CONTINUE_STAGE_ACTOR_SELECTTION_SUCCESS,
      ContStageActorData,
    };
  }

  function failure(error) {
    return {
      type: fileConstants.CONTINUE_STAGE_ACTOR_SELECTTION_FAILURE,
      error,
    };
  }
};

fileActions.GetFileInfoByFolio = (data) => {
  return (dispatch) => {
    dispatch(request());
    fileRequests.GetFileInfoByFolio(data).then(
      (fileFolioData) => dispatch(success(fileFolioData)),
      (error) => dispatch(failure(handleErrorMessage(error)))
    );
  };

  function request() {
    return { type: fileConstants.GETFILE_BY_FOLIO_REQUEST };
  }

  function success(fileFolioData) {
    return { type: fileConstants.GETFILE_BY_FOLIO_SUCCESS, fileFolioData };
  }

  function failure(error) {
    return { type: fileConstants.GETFILE_BY_FOLIO_FAILURE, error };
  }
};

fileActions.GenerateFolioExterno = (data) => {
  return (dispatch) => {
    dispatch(request());
    fileRequests.GenerateFolioExterno(data).then(
      (folioExtData) => dispatch(success(folioExtData)),
      (error) => dispatch(failure(handleErrorMessage(error)))
    );
  };

  function request() {
    return { type: fileConstants.GENERATE_FOLIO_EXTERNO_REQUEST };
  }

  function success(folioExtData) {
    return { type: fileConstants.GENERATE_FOLIO_EXTERNO_SUCCESS, folioExtData };
  }

  function failure(error) {
    return { type: fileConstants.GENERATE_FOLIO_EXTERNO_FAILURE, error };
  }
};

fileActions.RegisterSurveyAnswers = (data) => {
  return dispatch => {
    dispatch(request())
    fileRequests.RegisterSurveyAnswers(data)
      .then(
        fileData => dispatch(success(fileData)),
        error => dispatch(failure(handleErrorMessage(error)))
      )
  }

  function request() {
    return { type: fileConstants.SURVEY_SEND_REQUEST }
  }

  function success(fileData) {
    return { type: fileConstants.SURVEY_SEND_SUCCESS, fileData }
  }

  function failure(error) {
    return { type: fileConstants.SURVEY_SEND_FAILURE, error }
  }
}

fileActions.GetSurveyQuestions = (data) => {
  return dispatch => {
    dispatch(request())
    fileRequests.GetSurveyQuestions(data)
      .then(
        surveyInfo => dispatch(success(surveyInfo)),
        error => dispatch(failure(handleErrorMessage(error)))
      )
  }

  function request() {
    return { type: fileConstants.GET_SURVEY_REQUEST }
  }

  function success(surveyInfo) {
    return { type: fileConstants.GET_SURVEY_SUCCESS, surveyInfo }
  }

  function failure(error) {
    return { type: fileConstants.GET_SURVEY_FAILURE, error }
  }
}